var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.512 1.6665C16.9951 1.6665 17.4585 1.85836 17.8002 2.1999C17.9697 2.36919 18.1042 2.57024 18.1959 2.79154C18.2876 3.01284 18.3347 3.25005 18.3347 3.4896C18.3346 3.72915 18.2873 3.96633 18.1955 4.18759C18.1037 4.40884 17.9691 4.60981 17.7995 4.77901L15.3689 7.20952L12.7932 4.63388L15.2238 2.1999C15.5655 1.85836 16.0289 1.6665 16.512 1.6665ZM1.66699 15.7568L11.8088 5.61607L14.3846 8.19172L4.24342 18.3332H1.66699V15.7568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.8bd1b67417ebde52f1e6e783f11c495c.svg";
export { ForwardRef as ReactComponent };